/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Season_CalendarInputs */

const en_nav_season_calendar = /** @type {(inputs: Nav_Season_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Season calendar`)
};

/**
* | output |
* | --- |
* | "Season calendar" |
*
* @param {Nav_Season_CalendarInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_season_calendar = /** @type {((inputs?: Nav_Season_CalendarInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Season_CalendarInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_season_calendar(inputs)
});